import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Samurai",
  "description": "",
  "published": "2007-01-20T00:00:00.000Z",
  "redirect_from": ["/blog/samurai/swizec/314"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Na forumu, ki ga vcasih obiscem, je nekdo omenil animacijo lastne izdelave, risanko v bistvu. Ocitno je narejena z uporabo samanisticnih tehnik naprednih animatorjev in dodatki popra ter pridihom carovnije, ki ustvari`}<a parentName="p" {...{
        "href": "http://www.threeleggedlegs.com/work/samurai/"
      }}>{` to cudovito kratko risanko`}</a>{`, ki vam bo vzela sapo.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      